export default __webpack_public_path__ + "static/media/dav-arms.955864dd.jpg";